module.exports = require('./helpers/bundle-url').getBundleURL('dE9Yt') + "logo.c51670a8.svg";